import { render, staticRenderFns } from "./message-modal.vue?vue&type=template&id=5bbc0689&"
import script from "./message-modal.vue?vue&type=script&lang=js&"
export * from "./message-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports